import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const IconX = React.forwardRef<SVGSVGElement, any>((props, ref) => {
  return (<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon-x" data-icon="icon-x" aria-hidden="true" {...props} ref={ref}><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>);
});

IconX.displayName = 'IconX';
